import React, { createContext, useContext, useReducer } from "react"
import { getRequest, pathname } from "@react/helpers/fetch"

const PanoramaContext = createContext(null)

const updateTaskInTree = (tree, id, patch) =>
  tree.map(task => {
    if (task.id === id) return { ...task, ...patch }
    if (task.children?.length) return { ...task, children: updateTaskInTree(task.children, id, patch) }
    return task
  })

const reducer = (state, action) => {
  switch (action.type) {
    case "REPLACE_STATE":
      return action.data
    case "PATCH_TASK":
      return { ...state, tasks: updateTaskInTree(state.tasks, action.id, action.patch) }
    case "PATCH_TASKS": {
      let tasks = state.tasks
      action.patches.forEach(({ id, patch }) => {
        tasks = updateTaskInTree(tasks, id, patch)
      })
      return { ...state, tasks }
    }
    default:
      return state
  }
}

export const PanoramaProvider = ({ data, children }) => {
  const [state, dispatch] = useReducer(reducer, data)
  const refresh = () =>
    getRequest(pathname({ path: `/projects/${data.project.id}`, format: "json" }))
      .then(fresh => dispatch({ type: "REPLACE_STATE", data: fresh }))
      .catch(() => {})
  return (
    <PanoramaContext.Provider value={{ state, dispatch, refresh }}>
      {children}
    </PanoramaContext.Provider>
  )
}

export const usePanorama = () => {
  const ctx = useContext(PanoramaContext)
  if (!ctx) throw new Error("usePanorama must be used within PanoramaProvider")
  return ctx
}
